<template>
  <b-modal
    ref="modal"
    v-bind="$attrs"
    :dialog-class="{ 'full-height': fullHeight }"
    :modal-class="type"
    :no-close-on-backdrop="noClose"
    lazy
    v-on="$listeners"
  >
    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot v-bind="scope" :name="slot" />
    </template>
  </b-modal>
</template>
<script>
export default {
  props: {
    type: String,
    name: {
      required: true,
      type: String,
    },
    noClose: {
      type: Boolean,
      default: true,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {},
    }
  },
  mounted() {
    this.$root.$on('modal-show', this.onShow)
    this.$root.$on('modal-hide', this.onHide)
  },
  beforeDestroy() {
    this.$root.$off('modal-show', this.onShow)
    this.$root.$off('modal-hide', this.onHide)
  },
  methods: {
    onShow(name) {
      if (name === this.name) {
        this.$refs.modal.show()
      }
    },
    onHide(name) {
      this.params = {}
      if (name === this.name) {
        this.$refs.modal.hide()
      }
    },
    close() {
      this.$refs.modal.hide()
    },
  },
}
</script>
